import React, { useState } from "react";

import axios from 'axios';
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { updateShippingDetails } from "../../Redux/Actions/actions";
import { useElements, useStripe, CardElement } from '@stripe/react-stripe-js';

import "./shippingdetails.css";

const ShippingDetails = (props) => {
  const [modal, setModal] = useState(false);
  const elements = useElements();
  const stripe = useStripe();

  const [shippingDetails, setShippingDetails] = useState({
    firstname: "",
    lastname: "",
    address: "",
    zipcode: "",
    state: "",
    city: "",
    message: "",
  });


  const checkout = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }


    const { clientSecret } = await fetch('https://dreamflowersbk.herokuapp.com/create-payment-intent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        PaymentMethodType: 'card',
        currency: 'usd',
      }),
    }).then(r => r.json());

    stripe.confirmCardPayment(
      clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement)
      }
    }
    )
    // console.log("i m  GREAT DEVELOPER!");
    // axios.post('https://dreamflowersbk.herokuapp.com/createcheckoutsession')
    //   .then(response =>
    //     window.location.href = response.data.url
    //   ).catch((err) => console.log('error is: ', err))
  }

  // const checkout = async (event) => {
  //   event.preventDefault();
  //   console.log("i m  GREAT DEVELOPER!");
  //   const res = await fetch(`https://dreamflowersbk.herokuapp.com/create-checkout-session`, {
  //     method: 'POST',
  //   })
  //   const body = await res.json()
  //   window.location.href = body.url
  // }


  return (
    <div>
      <form className="shippingForm-Container">
        <h1 className="shippingForm-Title"> Shipping Details </h1>
        <div className="shippingForm-NameContainer">
          <div>
            First name:
            <br />
            <input
              required
              className="shippingForm-Input"
              type="text"
              name="first name"
              value={shippingDetails.firstname}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  firstname: e.target.value,
                })
              }
            />
          </div>
          <div>
            Last name:
            <br />
            <input
              required
              className="shippingForm-Input"
              type="text"
              name="last name"
              value={shippingDetails.lastname}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  lastname: e.target.value,
                })
              }
            />
          </div>
        </div>
        <br />
        <div>
          Address:
          <br />
          <input
            required
            className="shippingForm-Address"
            type="text"
            name="address"
            value={shippingDetails.address}
            onChange={(e) =>
              setShippingDetails({
                ...shippingDetails,
                address: e.target.value,
              })
            }
          />
        </div>
        <br />
        <div className="shippingForm-LocationInformation">
          <div>
            Zip Code:
            <br />
            <input
              required
              className="shippingForm-Input shipping-Zipcode"
              type="number"
              name="zip code"
              value={shippingDetails.zipcode}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  zipcode: e.target.value,
                })
              }
            />
            <br />
            State:
            <br />
            <input
              required
              className="shippingForm-Input"
              type="text"
              name="state"
              value={shippingDetails.state}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  state: e.target.value,
                })
              }
            />
            <br />
            City:
            <br />
            <input
              required
              className="shippingForm-Input"
              type="text"
              name="city"
              value={shippingDetails.city}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  city: e.target.value,
                })
              }
            />
            <br />
          </div>
          <div>
            Message:
            <br />
            <textarea
              className="shippingDetails-Message"
              name="message"
              placeholder="Enter message you would like us to see!"
              value={shippingDetails.message}
              onChange={(e) =>
                setShippingDetails({
                  ...shippingDetails,
                  message: e.target.value,
                })
              }
            ></textarea>
          </div>
        </div>
        <CardElement />
        <div className="shippingDetails-Footer">
          <Link
            className="shippingDetails-ShoppingCartButton"
            to="/shoppingcart"
          >
            Shopping Cart
          </Link>
          {console.log("Shipping details are :", shippingDetails)}
          <input
            type="submit"
            className="shippingDetails-SubmitButton"
            onClick={(e) => {
              props.updateShippingDetails(shippingDetails);
              // checkout(e)
              alert("Your items are being shipped!");
            }}
            value="Submit"
          />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    shippingDetails: state.ShippingReducer.shippingDetails,
    addedItems: state.CartReducer.addedItems,
    total: state.CartReducer.total,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateShippingDetails: (shippingDetails) => {
      dispatch(updateShippingDetails(shippingDetails));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingDetails);
